import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/index'

import layout from '../views/layout.vue'
import dashboard_index from '../views/dashboard/index'
import user_list from '../views/user/list.vue'
import mypage_index from '../views/mypage/index.vue'
import money_list from '../views/money/list.vue'
import moneylogs_user_list from '../views/moneylogs_user/list.vue'
import order_list from '../views/order/list.vue'
import moneylogs_list from '../views/moneylogs/list.vue'
import calcuser_list from '../views/calcuser/list.vue'
import online_list from '../views/online/list.vue'
import bon_list from '../views/bon/list.vue'
import bubon_list from '../views/bubon/list.vue'
import jang_list from '../views/jang/list.vue'
import zp_list from '../views/zp/list.vue'
import moneybak_list from '../views/moneybak/list.vue'
import refresh from '../components/common/refresh.vue'
import buy_list from '../views/buy/list.vue'
import inout_list from '../views/inout/list.vue'
import inoutzp_list from '../views/inoutzp/list.vue'
import memlist_list from '../views/memlist/list.vue'
import management_list from '../views/management/list.vue'
import losinglist_list from '../views/losinglist/list.vue'
import betting_list1 from '../views/betting1/list.vue'
import calculation_list from '../views/calculation/list.vue'
import calculation_new_list from '../views/calculation_new/list.vue'
import redirect from '../components/redirect.vue'
import sp_list from '../views/shop/list.vue'
import rdp_list from '../views/rdp/list.vue'
import qa_list from '../views/qa/list.vue'
import memo_list from '../views/memo/list.vue'
import coupon_list from '../views/coupon/list.vue'
import rolling_c_list from '../views/rolling_c/list.vue'
Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push=function push(to){
return VueRouterPush.call(this,to).catch(err=> err)
}

export default new Router({
  routes: [

  {
      path: '/refresh',
      name: 'refresh',
      component: refresh
    },
     {
     path: '/redirect',
     name: 'redirect',
     component: redirect
    },
    {
      path: '/',
      name: 'login',
      component: login
    },
   
    {
      path: '/index',
      name: 'layout',
      component: layout,
      redirect:'/user/list',
         children:[
         {
            path:'/dashboard/index',
            name:'dashboard_index',
            component:dashboard_index
          },
           {
            path:'/mypage/index',
            name:'mypage_index',
            component:mypage_index
          },
        
          {
            path:'/user/list',
            name:'user_list',
            component:user_list,
           

          },
            {
            path:'/calcuser/list',
            name:'calcuser_list',
            component:calcuser_list,
           

          },{
            path:'/moneylogs_user/list',
            name:'moneylogs_user_list',
            component:moneylogs_user_list,
           

          },{
            path:'/management/list',
            name:'management_list',
            component:management_list,
           

          },
           {
            path:'/memlist/list',
            name:'memlist_list',
            component:memlist_list,
           

          },  {
            path:'/calculation/list',
            name:'calculation_list',
            component:calculation_list,
           

          },{
            path:'/jang/list',
            name:'jang_list',
            component:jang_list,
           

          }, {
            path:'/calculation_new/list',
            name:'calculation_new_list',
            component:calculation_new_list,
           

          },{
            path:'/rdp/list',
            name:'rdp_list',
            component:rdp_list,
           

          },
          {
            path:'/rolling_c/list',
            name:'rolling_c_list',
            component:rolling_c_list
          },
           {
            path:'/qa/list',
            name:'qa_list',
            component:qa_list,
           

          },
           {
            path:'/memo/list',
            name:'memo_list',
            component:memo_list,
           

          },
         
           {
            path:'/coupon/list',
            name:'coupon_list',
            component:coupon_list,
           

          },
           {
            path:'/money/list',
            name:'money_list',
            component:money_list
          },
           {
            path:'/losinglist/list',
            name:'losinglist_list',
            component:losinglist_list
          },
           {
            path:'/shop/list',
            name:'sp_list',
            component:sp_list
          },
          
           {
            path:'/order/list',
            name:'order_list',
            component:order_list
          },
          
         
           {
            path:'/moneylogs/list',
            name:'moneylogs_list',
            component:moneylogs_list
          },
          
           {
            path:'/online/list',
            name:'online_list',
            component:online_list
          },
          {
            path:'/bon/list',
            name:'bon_list',
            component:bon_list
          },
          
          {
            path:'/bubon/list',
            name:'bubon_list',
            component:bubon_list
          },
        
          {
            path:'/zp/list',
            name:'zp_list',
            component:zp_list
          },
          
          
          
           {
            path:'/moneybak/list',
            name:'moneybak_list',
            component:moneybak_list
          },
          
           {
            path:'/buy/list',
            name:'buy_list',
            component:buy_list
          },
         
          
           {
            path:'/inout/list',
            name:'inout_list',
            component:inout_list
          },
           {
            path:'/inoutzp/list',
            name:'inoutzp_list',
            component:inoutzp_list
          },
          {
            path:'/betting1/list',
            name:'betting_list1',
            component:betting_list1
          }
         
         
           
          
      ]

    }
  ],
  mode:"history" 
})



// WEBPACK FOOTER //
// ./src/router/index.js